import { COLORS } from "@constants";
import styled from "styled-components";

interface Props {
  margin?: string;
}

function Divider({ margin }: Props) {
  return <Component $margin={margin} />;
}

export default Divider;

const Component = styled.hr`
  border-color: ${COLORS.NEUTRAL_200};
  margin: ${({ $margin }) => ($margin ? $margin : "0")};
  height: 1px;
  width: 100%;
`;
